export class PublisherService {
  static get publisherName(): string {
    try {
      const mappings = {
        Askaprice: ['local-aap', 'dev-aap', 'qa-aap', 'askaprice.com'],
        CarKeys: ['local-ck', 'dev-ck', 'qa-ck', 'carkeys.co.uk'],
        'Green.Car': ['qa-evlpb', 'green.car'],
        PetrolPrices: ['dev-pp', 'qa-pp', 'petrolprices.uk-tla.com'],
        'Van Guide': ['/van-guide', 'vanguide.co.uk']
      };

      const matchedNames = Object.entries(mappings)
        .filter(([_, value]) => value.some((li) => window.location.href.includes(li)))
        .map(([key, _]) => key);

      if (matchedNames.length === 1) {
        const publisherName = matchedNames[0];
        console.log('Publisher', publisherName);

        return publisherName;
      }
    } catch (error) {
      window.console.error(
        'Failed to get publisher name from URL',
        { error }
      );
    }

    return '';
  }
}

export default PublisherService;
